import View from './Menu';
import enhancer from './Menu.enhancer';

const Menu = enhancer(View);

export default Menu;
